import { render } from "./FaultContent.vue?vue&type=template&id=dc0ee9d8&scoped=true"
import script from "./FaultContent.vue?vue&type=script&lang=js"
export * from "./FaultContent.vue?vue&type=script&lang=js"

import "./FaultContent.vue?vue&type=style&index=0&id=dc0ee9d8&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0ee9d8"]])

export default __exports__